/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StandardConditionBulkUpdateForm } from '../../models/standard-condition-bulk-update-form';

export interface BulkUpdate$Params {

/**
 * Svg id
 */
  svgId: number;
      body: StandardConditionBulkUpdateForm
}

export function bulkUpdate(http: HttpClient, rootUrl: string, params: BulkUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, bulkUpdate.PATH, 'put');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

bulkUpdate.PATH = '/svgs/{svgId}/standard-conditions';
